import {BrowserModule} from '@angular/platform-browser';
import {NgModule, APP_INITIALIZER} from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import {ThemeModule} from '@labshare/base-ui/theme';
import {AppComponent} from './app.component';
import {labshare} from './theme/theme';
import {CommonModule} from '@angular/common';
import {Title} from '@angular/platform-browser';
import {FormlyModule} from '@ngx-formly/core';
import {FormlyBootstrapModule} from '@ngx-formly/bootstrap';
import {ReactiveFormsModule} from '@angular/forms';
import {NgxJsonViewerModule} from 'ngx-json-viewer';
import {
  NgxCoreServicesModule,
  AuthService,
  ConfigService,
  initializeFromAppConf,
  AppType,
  AuthInterceptor
} from '@labshare/ngx-core-services';
// this editor should be removed for a real project
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {HeaderLogoComponent} from './header-logo/header-logo.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AsrUserProfileComponent} from '../app/asr-user-profile/asr-user-profile.component';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FooterComponent} from './footer/footer.component';
import {LayoutComponent} from './layout/layout.component';
import {AsrApiTestComponent} from './asrapitest/asrapitest.component';

const customThemes = [labshare];
// Export Angular 8 feature module
// app initializer for Auth
// app initializer
function initialize(http: HttpClient, config: ConfigService, auth: AuthService): () => Promise<any> {
  return async () => {
    if (APP_TYPE === AppType.Site) {
      return initializeFromAppConf(http, config, auth);
    } else {
      return auth.configure().toPromise();
    }
  };
}
@NgModule({
  declarations: [
    AppComponent,
    HeaderLogoComponent,
    LayoutComponent,
    AsrUserProfileComponent,
    FooterComponent,
    AsrApiTestComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NgxCoreServicesModule.forRoot({appConf: APP_CONF, appType: APP_TYPE, appBuildVersion: APP_BUILD_VERSION}),
    ThemeModule.forRoot(customThemes),
    CommonModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormlyModule.forRoot(),
    NgxJsonViewerModule,
    FormlyBootstrapModule,
    NgbModule
  ],
  providers: [
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initialize,
      deps: [HttpClient, ConfigService, AuthService],
      multi: true
    },
    NgbActiveModal
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
